<template>
  <div>
    <div
      v-if="subcontractor"
      class="mb-1"
    >
      <small class="text-muted d-block">{{ $t('ledger_gl_account') }}</small>
      <strong>{{ glText }}</strong>
    </div>
    <b-form-group :label="$t('ledger_sub_name')">
      <b-form-input v-model="form.name" />
    </b-form-group>
    <b-form-group :label="$t('ledger_sub_name_en')">
      <b-form-input v-model="form.name_en" />
    </b-form-group>
    <b-row>
      <b-col cols="6">
        <b-form-group :label="$t('ledger_sub_tax')">
          <b-form-input v-model="form.tax_number" />
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group :label="$t('ledger_sub_phone')">
          <b-form-input v-model="form.phone" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group :label="$t('ledger_sub_email')">
      <b-form-input v-model="form.email" />
    </b-form-group>
    <b-form-group :label="$t('ledger_sub_address')">
      <b-form-input v-model="form.address" />
    </b-form-group>
    <b-form-group :label="$t('ledger_sub_specialty')">
      <b-form-input v-model="form.specialty" />
    </b-form-group>
    <b-form-checkbox
      v-model="form.is_active"
      class="mb-1"
    >
      {{ $t('ledger_sub_active') }}
    </b-form-checkbox>
    <b-form-group :label="$t('ledger_assets_notes')">
      <b-form-input v-model="form.notes" />
    </b-form-group>
    <b-button
      variant="primary"
      class="rounded-pill"
      :disabled="saving || !form.name"
      @click="save"
    >
      {{ $t('ledger_assets_save') }}
    </b-button>
  </div>
</template>

<script>
import {
  BFormGroup, BFormInput, BFormCheckbox, BButton, BRow, BCol,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { createSubcontractor, updateSubcontractor } from '@/api/accounting/subcontractors'
import { oneFrom, apiErrorMessage, glAccountText } from '@/utils/ledger'

export default {
  name: 'SubcontractorForm',
  components: {
    BFormGroup, BFormInput, BFormCheckbox, BButton, BRow, BCol,
  },
  props: {
    subcontractor: { type: Object, default: null },
  },
  data() {
    return { saving: false, form: this.blank() }
  },
  computed: {
    glText() {
      return glAccountText(this.subcontractor) || '—'
    },
  },
  watch: {
    subcontractor: {
      immediate: true,
      handler(value) {
        this.form = value ? {
          name: value.name || '',
          name_en: value.name_en || '',
          tax_number: value.tax_number || '',
          phone: value.phone || '',
          email: value.email || '',
          address: value.address || '',
          specialty: value.specialty || '',
          is_active: value.is_active !== false,
          notes: value.notes || '',
        } : this.blank()
      },
    },
  },
  methods: {
    blank() {
      return {
        name: '', name_en: '', tax_number: '', phone: '', email: '', address: '', specialty: '', is_active: true, notes: '',
      }
    },
    payload() {
      const body = { name: this.form.name.trim(), is_active: Boolean(this.form.is_active) }
      const optional = ['name_en', 'tax_number', 'phone', 'email', 'address', 'specialty', 'notes']
      optional.forEach(key => {
        const value = String(this.form[key] || '').trim()
        if (value) body[key] = value
      })
      return body
    },
    async save() {
      if (!this.form.name || this.saving) return
      this.saving = true
      try {
        const res = this.subcontractor
          ? await updateSubcontractor(this.subcontractor.id, this.payload())
          : await createSubcontractor(this.payload())
        this.$toast({
          component: ToastificationContent,
          props: { title: this.$t('ledger_sub_saved'), icon: 'CheckIcon', variant: 'success' },
        })
        this.$emit('saved', oneFrom(res))
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: apiErrorMessage(error, this.$t('ledger_error')),
            icon: 'AlertCircleIcon',
            variant: error?.response?.status === 422 ? 'warning' : 'danger',
          },
        })
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
